/* Hero-Slideshow: Crossfade-Karussell als Custom Element.
   Markup kommt aus sections/go-hero-slideshow.liquid. */
if (!customElements.get('go-hero-slideshow')) {
  customElements.define('go-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.slides = Array.from(this.querySelectorAll('.go-hero-slideshow__slide'));
      if (this.slides.length < 2) return;
      this.events = new AbortController();
      const { signal } = this.events;

      this.dots = Array.from(this.querySelectorAll('.go-hero-slideshow__dot'));
      this.liveRegion = this.querySelector('.go-hero-slideshow__live');
      this.index = this.slides.findIndex((s) => s.classList.contains('is-active'));
      if (this.index < 0) this.index = 0;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused ??= this.dataset.autoplay !== 'true';
      if (this.reducedMotion.matches) this.paused = true;
      this.hovered = false;
      this.intervalMs = (parseFloat(this.dataset.interval) || 3.5) * 1000;

      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i, true), { signal }));

      const prev = this.querySelector('.go-hero-slideshow__arrow--prev');
      const next = this.querySelector('.go-hero-slideshow__arrow--next');
      if (prev) prev.addEventListener('click', () => this.step(-1, true), { signal });
      if (next) next.addEventListener('click', () => this.step(1, true), { signal });

      this.addEventListener('mouseenter', () => { this.hovered = true; this.start(); }, { signal });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); }, { signal });
      this.addEventListener('focusin', () => { this.paused = true; this.start(); }, { signal });

      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches) this.paused = true;
        this.start();
      }, { signal });

      document.addEventListener('visibilitychange', () => this.start(), { signal });

      // Wischgesten (Mobile): einfacher Schwellwert von 40px horizontal
      this.addEventListener('touchstart', (e) => (this.touchX = e.changedTouches[0].clientX), { passive: true, signal });
      this.addEventListener(
        'touchend',
        (e) => {
          const dx = e.changedTouches[0].clientX - this.touchX;
          if (Math.abs(dx) > 40) this.step(dx < 0 ? 1 : -1, true);
        },
        { passive: true, signal }
      );

      this.setSlideState();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.events?.abort();
      this.events = null;
    }

    start() {
      this.stop();
      if (this.paused || this.hovered || document.hidden) return;
      this.timer = setInterval(() => this.step(1, false), this.intervalMs);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    step(direction, byUser) {
      const count = this.slides.length;
      this.goTo((this.index + direction + count) % count, byUser);
    }

    goTo(newIndex, byUser) {
      if (byUser) {
        this.paused = true;
        this.start();
      }
      if (newIndex === this.index) return;
      this.index = newIndex;
      this.setSlideState();
      if (byUser) {
        if (this.liveRegion) {
          this.liveRegion.textContent = 'Bild ' + (newIndex + 1) + ' von ' + this.slides.length;
        }
      }
    }

    setSlideState() {
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.inert = !active;
        slide.querySelectorAll('a').forEach((link) => {
          if (active) link.removeAttribute('tabindex');
          else link.setAttribute('tabindex', '-1');
        });
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  });
}
